import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import LineIcon from '../components/LineIcon';
import { plural } from '../garage/format';
import { useEvaluations, useProvider } from './ProviderContext';
import EvaluationRow from './EvaluationRow';
import EvaluationSheet from './EvaluationSheet';
import Stars from './Stars';
import { formatPercent, formatScore, summarize } from './providerFormat';

const LATEST = 3;

function Score({ summary }) {
  return (
    <section className='pv-score' aria-label='Resumo das avaliações'>
      <div className='pv-score-main'>
        <strong className='pv-score-value'>{formatScore(summary.average)}</strong>
        <Stars value={summary.average} showValue={false} size='md' />
        <span>{summary.total} {plural(summary.total, 'avaliação', 'avaliações')}</span>
      </div>
      <dl className='pv-score-list'>
        <div>
          <dt>Indicariam a oficina</dt>
          <dd>
            <span className='pv-bar' aria-hidden='true'><span style={{ width: `${summary.indicatePercent}%` }} /></span>
            <strong>{formatPercent(summary.indicatePercent)}</strong>
          </dd>
        </div>
        <div><dt>Produto ou serviço</dt><dd><Stars value={summary.product} /></dd></div>
        <div><dt>Preço</dt><dd><Stars value={summary.price} /></dd></div>
      </dl>
    </section>
  );
}

// Inicio da oficina: como os clientes avaliam e as avaliacoes mais recentes.
export default function HomePage() {
  const { company } = useProvider();
  const { loading, list, error, reload } = useEvaluations();
  const [open, setOpen] = useState(null);
  const summary = useMemo(() => summarize(list), [list]);
  const name = company ? company.tradingName || company.name : '';

  return (
    <div className='gs-stack'>
      <header className='gs-page-header'>
        <span className='gs-eyebrow'>Área da oficina</span>
        <h1>{name || 'Olá'}</h1>
        <p>Veja o que os clientes acham do seu atendimento.</p>
      </header>

      {loading && <div className='gs-skeleton' aria-busy='true' aria-label='Carregando avaliações' />}

      {!loading && error && (
        <p className='gs-notice gs-notice-error' role='alert'>
          Não foi possível carregar as avaliações.
          <button type='button' className='gs-link' onClick={reload}>Tentar de novo</button>
        </p>
      )}

      {!loading && !error && summary.total === 0 && (
        <section className='gs-empty'>
          <span className='gs-icon gs-icon-orange' aria-hidden='true'><LineIcon name='star' /></span>
          <h2>Ainda sem avaliações</h2>
          <p className='gs-muted'>Depois de cada venda ou ordem de serviço, o cliente recebe a pesquisa de satisfação. As respostas aparecem aqui.</p>
        </section>
      )}

      {!loading && !error && summary.total > 0 && (
        <>
          <Score summary={summary} />
          <section>
            <div className='pv-section-head'>
              <h2 className='gs-section-title'>Últimas avaliações</h2>
              {summary.total > LATEST && <Link to='/provider/evaluated' className='pv-more'>Ver todas</Link>}
            </div>
            <ul className='pv-list'>
              {list.slice(0, LATEST).map((evaluation) => (
                <EvaluationRow key={evaluation.key} evaluation={evaluation} onOpen={setOpen} />
              ))}
            </ul>
          </section>
        </>
      )}

      {open && <EvaluationSheet evaluation={open} onClose={() => setOpen(null)} />}
    </div>
  );
}
